<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/establish/fddetail',title:'返利管理'},{title:'返利发票数据明细'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">

            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
                        <el-form-item label="开票日期" class="timeselect" prop="erdat">
                            <el-date-picker
                                    @change="timeSelect"
                                    v-model="timeValue"
                                    type="daterange"
                                    value-format="yyyy-MM-dd"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    width="60"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="经销商编码" prop="kunrg">
                            <el-input style="width:1.6rem" v-model="q.kunrg" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="经销商名称" prop="kunrg">
                            <el-input style="width:1.6rem" v-model="q.kunrgT" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="发票号" prop="vbeln">
                            <el-input style="width:1.6rem" v-model="q.vbeln" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item class="h-formBtnOut">
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button @click="qingkong" class="h-btn h-formBtn"
                                       style="background-color:white;color:black;border:1px solid #d1d1d1">重置
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>


            <!--展示表格-->
            <div class="h-table h-mrt30">
                <div style="color: red;font-size: 12px;" v-show="zhanshi">{{dyyear}}年{{dymonth}}月的发票数据已于{{dydate}}导入成功</div>
                <el-table
                          ref="ddtable"
                          :data="tableData"
                          stripe
                          style="width: 100%"
                >
                    <!--<el-table-column
                            type="selection"
                    >
                    </el-table-column>
                    <el-table-column
                            type="index"
                            label="#"
                            width="40">
                    </el-table-column>-->
                    <el-table-column
                            prop="erdat"
                            :show-overflow-tooltip="true"
                            label="开票日期"
                            width="120"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="vbeln"
                            :show-overflow-tooltip="true"
                            label="发票号"
                            width="140"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="fkart"
                            :show-overflow-tooltip="true"
                            label="发票类型"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="fkartT"
                            :show-overflow-tooltip="true"
                            label="发票类型描述"
                            width="120">
                        <template slot-scope="scope">
                            {{scope.row.fkartT | dictname('fanli_fptype')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="vkorg"
                            :show-overflow-tooltip="true"
                            label="销售组织"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="kunrg"
                            :show-overflow-tooltip="true"
                            label="客户编码"
                            width="160"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="kunrgT"
                            :show-overflow-tooltip="true"
                            label="客户名称"
                            width="210"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="matnr"
                            :show-overflow-tooltip="true"
                            label="物料编码"
                            width="140"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="maktx"
                            :show-overflow-tooltip="true"
                            label="物料描述"
                            width="170"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="fkimg"
                            :show-overflow-tooltip="true"
                            label="物料数量"
                            width="100"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="wrbtr"
                            :show-overflow-tooltip="true"
                            label="开票金额（含税）"
                            width="160"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="zp00"
                            :show-overflow-tooltip="true"
                            label="内销基准价"
                            width="160"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="materialGroup3"
                            :show-overflow-tooltip="true"
                            label="是否计算销额"
                            width="150"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.materialGroup3=='X'">是</div>
                            <div v-if="scope.row.materialGroup3=='F'">否</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="materialGroup4"
                            :show-overflow-tooltip="true"
                            label="是否计算基数"
                            width="150"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.materialGroup4=='X'">是</div>
                            <div v-if="scope.row.materialGroup4=='F'">否</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="lianqun"
                            :show-overflow-tooltip="true"
                            label="链群"
                            width="120"
                    >
                        <template slot-scope="scope">
                            {{scope.row.lianqun | dictname('rebate_chain_group')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="aubel"
                            :show-overflow-tooltip="true"
                            label="订单号"
                            width="140"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="aupos"
                            :show-overflow-tooltip="true"
                            label="SW号"
                            width="120"
                    >
                    </el-table-column>
                </el-table>

                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel">批量导出
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                   @click="uploaddownexcelflagbtn" v-auth="'fanli_et_billing_upload'">批量导入
                        </el-button>
                        <uploaddownexcel
                                :visible.sync="uploaddownexcelflag"
                                v-if="uploaddownexcelflag"
                                clsname="invoiceInfoImportExcel"
                                :startrow="2" @callback="uploadExcelFilecallback"/>
                      <!--<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                 @click="uploaddownexcelflagbtnAdd" v-auth="'fanli_et_billing_upload'">冲销导入
                      </el-button>
                      <uploaddownexcel
                          :visible.sync="uploaddownexcelflagAdd"
                          v-if="uploaddownexcelflagAdd"
                          clsname="invoiceInfoAddImportExcel"
                          :startrow="2" @callback="uploadExcelFilecallbackAdd"/>-->
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'


    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                nowdate: this.$util.riQi(new Date()),
                uploaddownexcelflag: false,
              uploaddownexcelflagAdd:false,
                timeValue: null,
                value2: '',
                showhistory: false,
                instid: '',
                taskid: '',
                //查询属性
                page: {
                    contractBaseId: '',
                    pageSize: 20,
                    pageNo: 1
                },
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表单
                f: {
                    pageNo: 1,
                    id: null, //
                    contractBaseId: null, //
                    agentName: null, //
                    agentCode: null, //
                    contractStartTime: null, //
                    contractEndTime: null, //
                    contractOutTime: null, //
                    areaCode: null, //
                    area: null, //
                    channelCode: null, //
                    channel: null, //
                    cdate: null, //
                    ldate: null, //
                    cucode: null, //
                    cuname: null, //
                    lucode: null, //
                    delflag: null, //
                },
                //表格
                multipleSelection: [],

                //table列表
                tableData: [],
                flag: 0,
                //操作标志
                optflag: 'save',
                dyyear : null,
                dymonth : null,
                dydate : null,
                zhanshi : false,
            }
        },
        created() {
            this.query();
            this.getMessage();
        },
        methods: {
            getMessage(){
                ss.fanli.getInvoiceLog().then(rd => {
                    console.log("1111",rd)
                    if(rd && rd.dyyear){
                        this.dyyear = rd.dyyear;
                        this.dymonth = rd.dymonth;
                        this.dydate = rd.dydate;
                        this.zhanshi = true;
                    }
                });
            },
            //检索时间
            timeSelect() {
                if (this.timeValue == null || this.timeValue == '') {
                    this.q.startCdate = null;
                    this.q.endCdate = null;
                } else {
                    this.q.startCdate = this.timeValue[0];
                    this.q.endCdate = this.timeValue[1];
                }
            },
            //重置
            qingkong() {
                this.timeValue = null,
                    this.q = {
                        pageSize: 10,
                        pageNo: 1,
                        total: 0,
                    }
            },
            query() {
                ss.fanli.flInvoiceInfoPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                });
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //批量导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/demo/newEtBilling/downloadFlInvoiceExcel", this.q, "post");
            },
            //导入
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback() {
                this.query();
                this.$msg.msgs(rd.msg);
            },
          //导入
          uploaddownexcelflagbtnAdd() {
            this.uploaddownexcelflagAdd = true;
          },
          uploadExcelFilecallbackAdd() {
            this.query();
            this.$msg.msgs(rd.msg);
          },
        }
    }
</script>

<style scoped>

</style>
<style>
     .el-date-editor .el-range-separator {
        width:8%;
    }
</style>
